import { useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';

export const useBookingData = ({
  setPaymentConfig,
  setServices,
  setAvailableSlots,
  setLoyaltyInfo,
  formData,
}) => {
  const fetchPaymentConfig = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/payment/config`);
      setPaymentConfig(response.data);
    } catch (err) {
      console.error('Failed to fetch payment config:', err);
    }
  }, [setPaymentConfig]);

  const fetchServices = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/services`);
      setServices(response.data);
    } catch (err) {
      console.error('Failed to fetch services:', err);
    }
  }, [setServices]);

  const fetchAvailableSlots = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/available-slots`, {
        params: { date: formData.date, location: formData.location }
      });
      setAvailableSlots(response.data);
    } catch (err) {
      console.error('Failed to fetch available slots:', err);
    }
  }, [formData.date, formData.location, setAvailableSlots]);

  const fetchLoyaltyStatus = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/loyalty/${formData.client_email}`);
      setLoyaltyInfo(response.data);
    } catch (err) {
      console.error('Failed to fetch loyalty status:', err);
    }
  }, [formData.client_email, setLoyaltyInfo]);

  return { fetchPaymentConfig, fetchServices, fetchAvailableSlots, fetchLoyaltyStatus };
};
